import axios from "axios";
import { turnIntoLoader, turnIntoButton, openTheModal } from "../../functions";
import { forms } from "./elements";

let data;

export function submit(e) {
    e.preventDefault();

    removeError(".err");

    turnIntoLoader(e.submitter);

    data = Object.fromEntries(new FormData(e.target));

    const phoneInput = window.intlTelInputGlobals.getInstance(
        e.target.querySelector('[type="tel"]')
    );

    data.phone = data.phone
        ? `+${phoneInput.getSelectedCountryData().dialCode} ${data.phone}`
        : "";

    if (phoneInput.getValidationError() === 2) {
        createError(e.target, "Слишком короткий номер");
        turnIntoButton(e.submitter);
        return;
    }

    const res = axios
        .post("https://learn.aroken.ru/register", data, {
            withCredentials: true,
        })
        .then((res) => {
            if (e.target === forms["testdrive"]) {
                return openTheModal('[data-target="td-thank"]');
            } else if (e.target === forms["start-testdrive"]) {
                return openTheModal('[data-target="td-thank"]');
                //
                // const url = new URL(
                //     `${window.location.origin}/testdrive/success`
                // );
                //
                // window.location.href = url.href;
            }
        })
        .catch((err) => {
            for (const [key, value] of Object.entries(
                err.response.data.errors
            )) {
                createError(e.target, value);
            }
        })
        .finally(() => {
            turnIntoButton(e.submitter);
        });

    return false;
}

function createError(form, text) {
    let currentForm;

    if (typeof form === "string") {
        currentForm = document.querySelector(form);
    } else {
        currentForm = form;
    }

    currentForm?.insertAdjacentHTML(
        "beforeend",
        `<div class="err">
			${text}
		</div>`
    );
}

function removeError(selector) {
    const err = document.querySelectorAll(selector);
    for (const el of err) {
        el.remove();
    }
}
